import React, { useEffect, useRef } from "react";
import { useUnmount } from "react-use";
import { updateVideoStream } from "lib/liveStreamHelpers";
import { ProduceStream } from "types";
import BaseIcon from "components/BaseIcon";
import useResizeVideo from "./hooks/useResizeVideo";
import RippleAvatarAnimation from "../../../RippleAvatarAnimation";
import "./style.scss";

interface Props {
  item: ProduceStream;
  setPlayer?: React.Dispatch<React.SetStateAction<HTMLVideoElement | null>>;
  className?: string;
  mirrorReflection?: boolean;
  forceMute?: boolean;
  isSpeaking?: boolean;
  onClick?: () => void;
}

export default function SecondStreamView({
  item,
  setPlayer,
  forceMute,
  mirrorReflection,
  className,
  isSpeaking,
  onClick,
}: Props) {
  const videoWrapper = useRef<HTMLDivElement>(null);
  const player = useRef<HTMLVideoElement>(null);

  useResizeVideo({ player, videoWrapper, excludeParameter: ["width", "height"] });

  useEffect(() => {
    return updateVideoStream(player.current, item.stream);
  }, [item.stream, item.hasVideo, item.hasAudio, player]);

  useEffect(() => {
    setPlayer && setPlayer(player.current);
  }, [player, setPlayer]);

  const cls = ["second-stream-view pointer"];
  if (className) cls.push(className);
  if (!item.hasVideo) cls.push("__disabled-video");
  if (mirrorReflection) cls.push("__mirror-reflection");
  if (isSpeaking) cls.push("__speaking");

  useUnmount(() => {
    player.current && (player.current.srcObject = null);
  });

  return (
    <div ref={videoWrapper} className={cls.join(" ")} onClick={onClick}>
      <video className="second-stream-view__video" ref={player} muted={forceMute} playsInline autoPlay />
      {!item.hasVideo && (
        <RippleAvatarAnimation className="second-stream-view__animation" size={60} user={item.user.user} />
      )}
      {item.user.screenName && (
        <div className="second-stream-view__screen-name pa-1 truncate-ellipsis">{item.user.screenName}</div>
      )}
      {!item.hasAudio && (
        <div className="second-stream-view__muted">
          <BaseIcon className="second-stream-view__muted-icon" size={18}>
            mic_off
          </BaseIcon>
        </div>
      )}
    </div>
  );
}
